import { graphql } from '~/__gql__';

export const mutationStartTrial = graphql(/* GraphQL */ `
  mutation StartTrial($module: TRIAL_MODULE!) {
    startTrial(module: $module)
  }
`);

export const mutationRequestPricingUpsell = graphql(/* GraphQL */ `
  mutation RequestPricingUpsell($pricingPlan: PRICING_PLAN, $pricingAddOn: PRICING_ADD_ON) {
    requestPricingPlanUpsell(pricingPlan: $pricingPlan, pricingAddOn: $pricingAddOn)
  }
`);
